import React from "react";
import {
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Table from "@mui/material/Table";

type Props = {
  data: any;
  heading: string;
};

const SbuBidsTable = ({ data, heading }: Props) => {
  function createData(sbu: string, projectName: number, value: number) {
    return { sbu, projectName, value };
  }
  const rows: {
    sbu: string;
    projectName: number;
    value: number;
  }[] = [];

  if (data !== "No Bids") {
    for (let key in data) {
      rows.push(
        createData(data[key].sbu, data[key].projectName, data[key].value)
      );
    }
  }

  return (
    <TableContainer component={Paper} sx={{ maxHeight: "250px", mt: 1 }}>
      <Table aria-label="simple table">
        <TableHead sx={{ backgroundColor: "#348fea" }}>
          <TableRow>
            <TableCell sx={{ color: "white", p: 1 }} colSpan={3}>
              {heading}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#348fea" }}>
            <TableCell sx={{ color: "white", p: 1 }} key="sbu">
              SBU
            </TableCell>
            <TableCell sx={{ color: "white", p: 1 }} key="projectName">
              Project Name
            </TableCell>
            <TableCell sx={{ color: "white", p: 1 }} key="value">
              Value (INR Cr)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data !== "No Bids" ? (
            rows.map((row) => (
              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                key={row.projectName}
              >
                <TableCell align="left" sx={{ p: 1, width: "15%" }}>
                  {row?.sbu}
                </TableCell>
                <Tooltip title={row?.projectName} placement="top-start">
                  <TableCell
                    align="left"
                    sx={{
                      p: 1,
                      maxWidth: 20,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {row?.projectName}
                  </TableCell>
                </Tooltip>
                <TableCell align="left" sx={{ p: 1, width: "30%" }}>
                  {row?.value}{" "}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3}>No Bids</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SbuBidsTable;
